export const getIsNextButtonActive = (state) => state.isNextButtonActive;

export const getIsNextButtonClickable = (state) => state.isNextButtonClickable;

export const getIsScreenBlocked = (state) => state.isScreenBlocked;

export const getIsDownButtonEnabled = (state) => state.isDownButtonEnabled;

export const getIsDownButtonHighlighted = (state) => state.isDownButtonHighlighted;

export const getIsScreenGreyedOut = (state) => state.isScreenGreyedOut;

export const getIsBackButtonActive = (state) => state.isBackButtonActive;

export const getIsReadingReminderPopupActive = (state) => state.isReadingReminderPopupActive;

export const getIsScrollButtonClicked = (state) => state.isScrollButtonClicked;

export const getIsOkButtonGreyedOut = (state) => state.isOkButtonGreyedOut;

export const getIsTextPaneScrollEnabled = (state) => state.isTextPaneScrollEnabled;

export const isConfirmPopupActive = (state) => state.isConfirmPopupActive;

export const getIsLogoutModalVisible = (state) => state.isLogoutModalVisible;

export const getIsFileLoadingFailed = (state) => state.isFileLoadingFailed;

export const getIsAssessmentInstructionEnabled = (state) => state.isAssessmentInstructionEnabled;

export const getIsPointerClicked = (state) => state.isPointerClicked;

export const getPointerPosition = (state) => state.pointerPosition;

export const getIsPointerVisible = (state) => state.isPointerVisible;

export const getIsCircleButtonsVisible = (state) => state.isCircleButtonsVisible;

export const getIsSecondsTimerVisible = (state) => state.isSecondsTimerVisible;

export const getIsSecondsTimerActive = (state) => state.isSecondsTimerActive;

export const getCurrentLanguage = (state) => state.currentLanguage;

export const getIsHelpPopupVisible = (state) => state.isHelpPopupVisible;

export const getIsTRCPracticePopupActive = (state) => state.isTRCPracticePopupActive;

export const getIsSpinnerVisible = (state) => state.isSpinnerVisible;

export const getExternalURLSourceStatus = (state) => state.isExternalURLSourcePresent;

export const getisBenchmarkModeEnabled = (state) => state.isBenchmarkModeEnabled;

export const getArLanguage = (state) => state.arLanguage;

export const getBenchmarkId = (state) => state.benchmarkId;

export const getShouldEnableCaptions = (state) => state.shouldEnableCaptions;

export const getShouldDisplayCaption = (state) => state.shouldDisplayCaption;

export const getIsPauseButtonActive = (state) => state.isPauseButtonActive;

export const getisSettingsPopupVisible = (state) => state.isSettingsPopupVisible;
